import { SystemTranslation, TranslationSearch, TranslationService } from "@nt-portal/server-sdk";
import { BaseClientService } from "../base-client.service";
import { LanguageFile } from "../../../common";
import { ControllerOptions, DataController } from "../../../types";


export interface TranslationOptions extends ControllerOptions<SystemTranslation> {
    file?: File;
    module?: string;
    filter?: TranslationSearch
}

export const initializeTranslations = () => {
    let tr: SystemTranslation = {
        key: "",
        value: "",
        locale: "en",
        module: undefined,
        createdBy: ""
    }
    return tr;
}

export class ClientTranslationService extends BaseClientService implements DataController<SystemTranslation> {

    private _service: TranslationService;

    constructor() {
        super()
        this._service = new TranslationService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


    public async getLocale(locale: string) {
        const messages = await this._service.getLocale(locale, this.token)
        let lf: LanguageFile = {}
        let lfMessages: any = {}
        messages.forEach(m => {
            lfMessages[m.key] = m.value
        })
        lf[locale] = lfMessages;
        return lf;
    }

    public async get(options: TranslationOptions) {
        let fetchParams = this.buildFetchParams(options)
        return await this._service.get(fetchParams, this.token, options.filter);
    }


    public async getById(options: TranslationOptions) {
        if (options.id)
            return await this._service.getById(options.id, this.token);
        return null
    }


    public async add(options: TranslationOptions) {
        if (options.item)
            return await this._service.add(options.item, this.token);
        return null;
    }

    public async update(options: TranslationOptions) {
        if (options.item)
            return await this._service.update(options.item, this.token);
        return null;
    }


    public async delete(options: TranslationOptions) {
        if (options.id)
            return await this._service.delete(options.id, this.token);
    }

    public async import(options: TranslationOptions) {
        const { module, file } = options
        if (module && file)
            return await this._service.import(module, file, this.token)
        else 
            throw new Error("module and file are required")

    }

    public async export(options: TranslationOptions) {
        const { module } = options
        return await this._service.export( this.token, module)
      

    }
}